














































































































import { Component, Vue } from "vue-property-decorator";
import LoginAccountDetails from "./LoginV2/LoginAccountDetails.vue";
import LoginSecurityCode from "./LoginV2/LoginSecurityCode.vue";

@Component({
  components: {
    LoginAccountDetails,
    LoginSecurityCode
  }
})
export default class BusinessLogin extends Vue {
  step = 1;

  roleKey = "business";

  website = process.env.VUE_APP_WP_BASE || "";

  roles = {
    business: {
      name: "Business",
      description:
        "Login to manage your Quescreen business<br />account and to review Quescreen submissions."
    },
    candidate: {
      name: "Candidate",
      description:
        "Login to manage your personal Quescreen<br />account and complete a Quescreen"
    }
  };

  beforeMount() {
    if (this.$route.query?.role) {
      const queryRoleKey = this.$route.query.role as string;
      switch (queryRoleKey) {
        case "candidate":
          this.roleKey = "candidate";
          break;
        default:
          this.roleKey = "business";
          break;
      }
    }
  }

  beforeDestroy() {
    this.$store.commit("Auth/CLEAR_GUEST_STATE");
  }

  get isActivationSucceed() {
    return this.$route.query.activated === "1";
  }

  get isSessionTimedOut() {
    return !!this.$route.params.session_timed_out;
  }

  get toResetPassword() {
    if (this.roleKey === "candidate") {
      return {
        name: "v2-candidate-reset-password"
      };
    }

    return {
      name: "v2-business-reset-password"
    };
  }
}
